import script from "./ClassicUserLoginStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicUserLoginStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicUserLoginStep.vue?vue&type=style&index=0&id=f8dde00c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8dde00c"]])

export default __exports__